// extracted by mini-css-extract-plugin
export default {"main":"Contribute_main__pGZwW","title":"Contribute_title__41m1n","subtitle":"Contribute_subtitle__jsvma","cardGrid":"Contribute_cardGrid__+VqpM","link":"Contribute_link__sOE7Z"};